import { useState, useCallback } from 'react';
import { useSelector } from '../../../../../../redux/store';
import { RelatedInvoiceType } from '../../../../../../utils/globalEnums';

export const useWithDuplicateCheck = () => {
  const {
    data: {
      duplicateInvoices: { duplicates = [] },
      relatedInvoices: { related = [] },
    },
  } = useSelector((state) => state.invoicing);

  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [pendingSubmitLabel, setPendingSubmitLabel] = useState('Submit');
  const [pendingSubmitAction, setPendingSubmitAction] = useState(null);

  const handleSubmitAnyway = useCallback(
    (duplicateTypes = []) => {
      setShowDuplicatePopup(false);
      pendingSubmitAction?.(duplicateTypes); // pass types as argument
      setPendingSubmitAction(null);
    },
    [pendingSubmitAction]
  );
  
  const handleClose = useCallback(() => {
    setShowDuplicatePopup(false);
    setPendingSubmitAction(null);
  }, []);

  const withDuplicateCheck = useCallback(
    (submitFn, label = 'Submit') => {
      if (duplicates.length > 0) {
        setPendingSubmitAction(() => submitFn);
        setPendingSubmitLabel(label);
        setShowDuplicatePopup(true);
        return;
      }

      if (
        label !== 'Save' && //dont display pop on form save for potential duplicate
        related?.length > 0 &&
        related.some(
          (r) =>
            r.type === RelatedInvoiceType.PotentialDuplicate || r.type === RelatedInvoiceType.PotentialSpaceDuplicate
        )
      ) {
        setPendingSubmitAction(() => submitFn);
        setPendingSubmitLabel(label);
        setShowDuplicatePopup(true);
        return;
      }
      submitFn();
    },
    [duplicates, related]
  );

  return {
    withDuplicateCheck,
    showDuplicatePopup,
    pendingSubmitLabel,
    handleSubmitAnyway,
    handleClose,
  };
};
